"use client";

import type React from "react";
import styles from "./styles.module.css";

interface LoaderProps {
	className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ className }) => {
	return (
		<div className={`${styles.loaderContainer} ${className || ""}`}>
			<div className={styles.loader}></div>
		</div>
	);
};

export default Loader;
